import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ErrorFormatterService } from '@core/services/error-formatter.service';
import { ICampaignDetailsAnalyticsFetchParams } from './campaign-details.store';

@Injectable({
  providedIn: 'root',
})
export class CampaignDetailsErrorService {
  private readonly errorFormatterService = inject(ErrorFormatterService);

  public getLimitReached(error: HttpErrorResponse): boolean {
    const errorDetails = this.errorFormatterService.getErrorDetails(error.error);

    return errorDetails.some(
      (detail) =>
        detail.code === 'CREATOR_CHANNEL_LIMIT' ||
        detail.code === 'CONCURRENT_CAMPAIGN_LIMIT' ||
        detail.code === 'SEATS_LIMIT',
    );
  }

  public shouldMarkCampaignAsNotFound(error: unknown): boolean {
    if (error instanceof HttpErrorResponse) {
      return error.status === 404;
    }

    return false;
  }

  public buildCampaignInitializationError(error: unknown, params: ICampaignDetailsAnalyticsFetchParams | null): string {
    const campaignId = params?.campaignId ?? '';
    const readableError = this.getReadableError(error);

    if (!readableError) {
      return `Failed to load campaign: ${campaignId}`;
    }

    return `Failed to load campaign: ${campaignId}. ${readableError}`;
  }

  public getReadableError(error: unknown): string {
    if (error instanceof HttpErrorResponse) {
      const errorPayload: { message?: unknown } | null =
        error.error && typeof error.error === 'object' ? (error.error as { message?: unknown }) : null;
      const detail =
        typeof error.error === 'string'
          ? error.error
          : typeof errorPayload?.message === 'string'
            ? errorPayload.message
            : typeof error.message === 'string'
              ? error.message
              : '';

      return `HttpErrorResponse(status=${error.status}, url=${error.url ?? 'unknown'}, detail=${detail})`;
    }

    if (error instanceof Error) {
      return `${error.name}: ${error.message}`;
    }

    if (typeof error === 'string') {
      return error;
    }

    try {
      return JSON.stringify(error);
    } catch {
      return 'Unknown error';
    }
  }
}
